import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { CoreSeatApiNameByPaidProductLevel } from 'pricing-pages-lib/utils/productsUtils';
import { useCallback, useEffect } from 'react';
import { useAppSelector } from '../../reducers';
import { initialCoreSeatsTotalForProductConfigurationSelector } from '../../selectors/ProductConfigsSelectors';
import { currentSkuIdForProductSelector } from '../../selectors/ProductsSelectors';
export const useCoreSeats = ({
  productConfigurations,
  setProductConfigurations
}) => {
  const {
    total: initialCoreSeatsQuantity,
    updatedForUsers,
    updatedForOwnership,
    productLevelForCoreSeats,
    includedCoreSeatsQuantityAfterPurchase,
    ownedCoreSeatsQuantityAfterPurchase,
    currentOwnedCoreSeatsQuantity
  } = useAppSelector(state => initialCoreSeatsTotalForProductConfigurationSelector(state, {
    productConfigurations
  }));
  const apiNameForCoreSeats = CoreSeatApiNameByPaidProductLevel[productLevelForCoreSeats];
  const skuIdCoreSeat = useAppSelector(state => currentSkuIdForProductSelector(state, {
    apiName: apiNameForCoreSeats
  }));
  const foundConfig = productConfigurations.find(({
    skuId
  }) => skuId === skuIdCoreSeat);
  const purchasableCoreSeatsQuantity = foundConfig ? foundConfig.quantity : 0;
  const setPurchasableCoreSeatsQuantity = useCallback(quantity => {
    setProductConfigurations(oldProductConfigurations => {
      const filteredConfigs = oldProductConfigurations.filter(({
        skuId
      }) => skuId !== skuIdCoreSeat);
      filteredConfigs.push(createProductConfig({
        skuId: skuIdCoreSeat,
        quantity: quantity || 0
      }));
      return filteredConfigs;
    });
  }, [setProductConfigurations, skuIdCoreSeat]);
  useEffect(() => {
    if (purchasableCoreSeatsQuantity < ownedCoreSeatsQuantityAfterPurchase) {
      setPurchasableCoreSeatsQuantity(ownedCoreSeatsQuantityAfterPurchase);
    }
  }, [purchasableCoreSeatsQuantity, ownedCoreSeatsQuantityAfterPurchase, setPurchasableCoreSeatsQuantity]);
  return {
    productLevelForCoreSeats,
    includedCoreSeatsQuantity: includedCoreSeatsQuantityAfterPurchase,
    ownedCoreSeatsQuantity: ownedCoreSeatsQuantityAfterPurchase,
    currentOwnedCoreSeatsQuantity,
    initialCoreSeatsQuantity,
    updatedForUsers,
    updatedForOwnership,
    coreSeatsToPurchaseQuantity: purchasableCoreSeatsQuantity,
    setCoreSeatsToPurchaseQuantity: setPurchasableCoreSeatsQuantity
  };
};